import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "flex gap-2 mt-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = { class: "flex flex-col justify-between h-full" }
const _hoisted_6 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_7 = { class: "max-w-[1040px]" }
const _hoisted_8 = { class: "max-w-[1040px]" }
const _hoisted_9 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = { class: "text-gray-900" }
const _hoisted_12 = { class: "flex justify-end align-center" }
const _hoisted_13 = { class: "max-w-[1040px]" }
const _hoisted_14 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_15 = { class: "flex justify-end" }
const _hoisted_16 = { class: "flex justify-end align-center" }
const _hoisted_17 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_18 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_19 = { class: "flex justify-end" }
const _hoisted_20 = { class: "flex justify-between items-center" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex items-center justify-between gap-6" }
const _hoisted_23 = { class: "max-w-[1040px]" }
const _hoisted_24 = { class: "flex items-center justify-between gap-6" }
const _hoisted_25 = {
  key: 0,
  class: "grid gap-5 border-t border-gray-100 pt-5 sm:grid-cols-2"
}
const _hoisted_26 = { class: "flex items-center justify-between gap-6" }
const _hoisted_27 = {
  key: 0,
  class: "grid gap-5 border-t border-gray-100 pt-5 sm:grid-cols-2"
}
const _hoisted_28 = {
  key: 0,
  class: "max-w-[1040px]"
}
const _hoisted_29 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_30 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_31 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_32 = { class: "flex justify-end" }
const _hoisted_33 = { class: "text-gray-700 cursor-pointer" }
const _hoisted_34 = { class: "break-words whitespace-normal pr-4" }
const _hoisted_35 = { class: "flex justify-end align-center" }
const _hoisted_36 = { class: "max-w-[1040px]" }
const _hoisted_37 = { class: "grid items-start gap-5 sm:grid-cols-2" }
const _hoisted_38 = { class: "grid items-start gap-5 sm:grid-cols-2" }
const _hoisted_39 = { class: "max-w-[1040px]" }
const _hoisted_40 = { class: "flex items-center gap-2" }
const _hoisted_41 = { class: "flex items-center justify-between gap-6" }

import { CheckIcon, UserGroupIcon } from '@heroicons/vue/20/solid'
import { XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, reactive, ref, watch } from 'vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'

import NeueTablist from '@/components/neue/NeueTablist'
import NeueWell from '@/components/neue/NeueWell.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import {
  blankMembershipFees,
  blankOneTimeFee,
  blankRecurringFee,
  membershipFeeAttributes,
  oneTimeFeeFromServer,
  recurringFeeFromServer
} from '@/composables/membershipFees'
import { useBackLink } from '@/composables/useBackLink'
import { useRouteTabs } from '@/composables/useRouteTabs'
import { useToast } from '@/composables/useToast'
import { useUnloadGuard } from '@/composables/useUnloadGuard'
import { tierViewPath } from '@/config/membershipTierView'
import store from '@/store'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'MembershipTierNeue',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const backLink = useBackLink(tierViewPath(route.params.id))
const { showToast } = useToast()
const isMobileViewport = () => window.matchMedia('(max-width: 640px)').matches
const tier = computed(() => mapRelationship({ type: 'membership_tier', id: route.params.id }))
const tiers = computed(() => mapType('membership_tier'))
const stores = computed(() => mapType('store'))
const upgrades = computed(() => mapRelationships(tier.value?.relationships.upgrade_membership_tiers.data))

const hasUnsavedChanges = ref(false)
const loading = ref(true)
const leaveModal = ref(false)
let pendingRoute = null

useUnloadGuard(hasUnsavedChanges)

onBeforeRouteLeave(to => {
  if (!hasUnsavedChanges.value) return true
  pendingRoute = to.fullPath
  leaveModal.value = true
  return false
})

const confirmLeave = () => {
  hasUnsavedChanges.value = false
  leaveModal.value = false
  router.push(pendingRoute)
}

const waiting = reactive({})

const local = reactive({
  name: '',
  description: '',
  default: false,
  cartSubscription: {
    intervals: {},
    defaultInterval: null,
    defaultStore: null
  },
  membershipFee: blankMembershipFees(),
  template: {
    autocharge: {
      string: 'hours',
      number: 0,
      multiplier: -1
    },
    autofill: ''
  },
  moveTier: null,
  membersMoved: false,
  downgrade: null,
  pass: {
    existsOnServer: false,
    enabled: false,
    id: null,
    pairId: null,
    name: '',
    description: '',
    billingPrice: 0,
    billingInterval: 'weekly',
    autoSelect: false,
    rewards: [],
    sharedTierCount: 0
  },
  mealPlan: {
    enabled: false,
    id: null,
    priceCents: 0,
    billingInterval: 'weekly',
    itemCount: 5,
    categoryId: null,
    grantInterval: 'weekly',
    grantDay: 'monday',
    grantDate: 1,
    rollover: 'week',
    customExpiry: { expiry_value: null, expiry_type: null }
  }
})

const tierTabs = computed(() =>
  [
    { id: 'main', name: 'Main info' },
    { id: 'upgrades', name: 'Upgrades' },
    { id: 'subscriptions', name: 'Cart subscriptions' },
    { id: 'membership-fees', name: 'Membership fees' },
    local.pass.existsOnServer && { id: 'passes', name: 'Passes' },
    { id: 'meal-plans', name: 'Meal plans' },
    { id: 'actions', name: 'Actions' }
  ].filter(Boolean)
)
const { activeTab, sections: tierSections } = useRouteTabs(
  tierTabs,
  computed(() => `/store/membership-tiers/${route.params.id}/edit`)
)

const /* reminder */ modal = reactive({ open: false })
const upgradeModal = reactive({ open: false, id: null })
const rewardsModal = reactive({
  open: false,
  mode: 'add',
  type: '',
  reward: null,
  immediateAmount: 0,
  creditAmount: 0,
  creditInterval: { type: 'weekly', dayOfWeek: 0, dayOfMonth: 1 },
  creditAutoApply: false,
  creditExpiryEnabled: false,
  creditExpiry: { number: 1, string: 'weeks' }
})

const discard = () => {
  local.name = tier.value.attributes.tier_name
  local.description = tier.value.attributes.description
  local.default = tier.value.attributes.is_default

  for (const interval of intervals.value) {
    local.cartSubscription.intervals[interval.id] = {
      string: interval.attributes.setting_string_value ?? 'days',
      number: interval.attributes.setting_integer_value
    }
  }

  local.cartSubscription.defaultInterval = intervals.value.find(x => x.attributes.is_default)?.id ?? null
  local.cartSubscription.defaultStore =
    storeSettings.value.find(x => x.attributes.is_default)?.attributes.setting_integer_value.toString() ?? null

  if (templateAutocharge.value) {
    let value = templateAutocharge.value.attributes.offset_value
    if (templateAutocharge.value.attributes.offset_type === 'hours') value *= 60
    if (templateAutocharge.value.attributes.offset_type === 'days') value *= 60 * 24
    const days = Math.floor(value / (60 * 24))
    local.template.autocharge.multiplier = Math.sign(days)
    local.template.autocharge.days = Math.abs(days)
    const minutes = value - 60 * 24 * local.template.autocharge.days * local.template.autocharge.multiplier
    local.template.autocharge.time =
      String(Math.floor(minutes / 60)).padStart(2, 0) + ':' + String(minutes % 60).padStart(2, 0)
  }

  if (autofillFields.value) {
    local.template.autofill = autofillFields.value.find(x => x.attributes.key === 'type')?.attributes.text_value ?? null
  }

  local.downgrade = tier.value.attributes.upgrade_for_membership_tier_id?.toString() ?? null

  loadMembershipFees()

  const pass = mapRelationship(tier.value?.relationships.membership_pass?.data)
  const pair = mapRelationship(tier.value?.relationships.membership_tier_membership_pass_pair?.data)
  if (pass) {
    local.pass.existsOnServer = true
    local.pass.enabled = true
    local.pass.id = pass.id
    local.pass.pairId = pair?.id ?? null
    local.pass.name = pass.attributes.name ?? ''
    local.pass.description = pass.attributes.description ?? ''
    local.pass.billingPrice = (pass.attributes.price_cents ?? 0) / 100
    local.pass.billingInterval = pass.attributes.billing_interval ?? 'weekly'
    local.pass.autoSelect = Boolean(pass.attributes.auto_select)
    local.pass.rewards = (pass.relationships.membership_pass_rewards?.data ?? []).map(mapPassReward).filter(Boolean)
    local.pass.sharedTierCount = pass.relationships.membership_tiers?.data?.length ?? 0
  } else {
    local.pass.existsOnServer = false
    local.pass.enabled = false
    local.pass.id = null
    local.pass.pairId = null
    local.pass.name = ''
    local.pass.description = ''
    local.pass.billingPrice = 0
    local.pass.billingInterval = 'weekly'
    local.pass.autoSelect = false
    local.pass.rewards = []
    local.pass.sharedTierCount = 0
  }

  const mealPlan = mapRelationship(tier.value?.relationships.meal_plan?.data)
  if (mealPlan) {
    local.mealPlan.enabled = true
    local.mealPlan.id = mealPlan.id
    local.mealPlan.priceCents = mealPlan.attributes.price_cents ?? 0
    local.mealPlan.billingInterval = mealPlan.attributes.billing_interval ?? 'weekly'
    local.mealPlan.itemCount = mealPlan.attributes.item_count ?? 5
    local.mealPlan.categoryId = mealPlan.attributes.category_id ?? null
    local.mealPlan.grantInterval = mealPlan.attributes.grant_interval ?? 'weekly'
    local.mealPlan.grantDay = mealPlan.attributes.grant_day ?? 'monday'
    local.mealPlan.grantDate = mealPlan.attributes.grant_date ?? 1
    const expiryValue = mealPlan.attributes.expiry_value
    const expiryType = mealPlan.attributes.expiry_type
    if (expiryType === 'week' && expiryValue === 1) {
      local.mealPlan.rollover = 'week'
      local.mealPlan.customExpiry = { expiry_value: null, expiry_type: null }
    } else if (expiryType === 'month' && expiryValue === 1) {
      local.mealPlan.rollover = 'month'
      local.mealPlan.customExpiry = { expiry_value: null, expiry_type: null }
    } else if (expiryValue === null && expiryType === null) {
      local.mealPlan.rollover = 'never'
      local.mealPlan.customExpiry = { expiry_value: null, expiry_type: null }
    } else {
      local.mealPlan.rollover = 'custom'
      local.mealPlan.customExpiry = { expiry_value: expiryValue, expiry_type: expiryType }
    }
  } else {
    local.mealPlan.enabled = false
    local.mealPlan.id = null
    local.mealPlan.priceCents = 0
    local.mealPlan.billingInterval = 'weekly'
    local.mealPlan.itemCount = 5
    local.mealPlan.categoryId = null
    local.mealPlan.grantInterval = 'weekly'
    local.mealPlan.grantDay = 'monday'
    local.mealPlan.grantDate = 1
    local.mealPlan.rollover = 'week'
    local.mealPlan.customExpiry = { expiry_value: null, expiry_type: null }
  }

  hasUnsavedChanges.value = false
  loading.value = false
}

const load = id => {
  loading.value = true
  local.moveTier = null
  local.membersMoved = false
  Promise.all([
    api.call(
      'GET',
      `membership_tiers/${id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings,one_time_membership_fee,recurring_membership_fee,membership_tier_membership_pass_pair,membership_pass,membership_pass.membership_pass_rewards,membership_pass.membership_tiers,meal_plan`
    ),
    api.call(
      'GET',
      `membership_tiers/${id}/bottle_cycle_templates?included=bottle_autocharge_automation,bottle_autofill_automation,bottle_autofill_automation.automation_fields,bottle_reminder_automations,bottle_reminder_automations.message_template`
    )
  ]).then(discard)
}
load(route.params.id)
onBeforeRouteUpdate((to, from) => {
  if (to.params.id !== from.params.id) load(to.params.id)
})
api.call('GET', 'membership_tiers?included=none')

const save = async () => {
  if (local.mealPlan.enabled && !local.mealPlan.categoryId) {
    showToast('Choose a meal category before saving', { type: 'error' })
    return
  }

  const membershipTierData = {
    tier_name: local.name,
    description: local.description,
    is_default: local.default,
    cart_subscription_settings_attributes: [
      ...intervals.value.map(x => ({
        id: x.id,
        setting_string_value: local.cartSubscription.intervals[x.id].string,
        setting_integer_value: local.cartSubscription.intervals[x.id].number,
        is_default: local.cartSubscription.defaultInterval == x.id
      })),
      ...storeSettings.value.map(x => ({
        id: x.id,
        is_default: local.cartSubscription.defaultStore == x.attributes.setting_integer_value
      }))
    ],
    upgrade_for_membership_tier_id: local.downgrade
  }

  Object.assign(membershipTierData, membershipFeeAttributes(local.membershipFee))

  if (local.mealPlan.enabled) {
    const expiry =
      local.mealPlan.rollover === 'custom'
        ? { ...local.mealPlan.customExpiry }
        : {
            week: { expiry_value: 1, expiry_type: 'week' },
            month: { expiry_value: 1, expiry_type: 'month' },
            never: { expiry_value: null, expiry_type: null }
          }[local.mealPlan.rollover]
    membershipTierData.meal_plan_attributes = {
      id: local.mealPlan.id || undefined,
      price_cents: local.mealPlan.priceCents,
      billing_interval: local.mealPlan.billingInterval,
      item_count: local.mealPlan.itemCount,
      category_id: local.mealPlan.categoryId,
      grant_interval: local.mealPlan.grantInterval,
      grant_day: local.mealPlan.grantDay,
      grant_date: local.mealPlan.grantDate,
      ...expiry
    }
  } else if (local.mealPlan.id) {
    membershipTierData.meal_plan_attributes = { id: local.mealPlan.id, _destroy: true }
  }

  const membershipTierResponse = await api.call(
    'PUT',
    `membership_tiers/${route.params.id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings,one_time_membership_fee,recurring_membership_fee,meal_plan`,
    {
      membership_tier: membershipTierData
    }
  )

  syncMembershipFeeIds(membershipTierResponse)

  if (local.mealPlan.enabled) {
    let createdMealPlan = null

    if (membershipTierResponse.data?.included) {
      createdMealPlan = mapRelationship(membershipTierResponse.data.included.find(x => x.type === 'meal_plan'))
    }

    if (!createdMealPlan && membershipTierResponse.data?.data?.relationships?.meal_plan?.data) {
      createdMealPlan = mapRelationship(membershipTierResponse.data.data.relationships.meal_plan.data)
    }

    if (createdMealPlan) {
      local.mealPlan.id = createdMealPlan.id
    }
  } else if (local.mealPlan.id) {
    local.mealPlan.id = null
  }

  if (template.value) {
    if (templateAutocharge.value) {
      const hours = Number(local.template.autocharge.time.split(':')[0])
      const minutes = Number(local.template.autocharge.time.split(':')[1])
      api.call(
        'PUT',
        `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_autocharge_automation`,
        {
          bottle_cycle: {
            bottle_autocharge_automation_attributes: {
              id: templateAutocharge.value.id,
              offset_type: 'minutes',
              offset_value:
                (local.template.autocharge.days ?? 0) * 60 * 24 * local.template.autocharge.multiplier +
                hours * 60 +
                minutes
            }
          }
        }
      )
    }

    api.call(
      'PUT',
      `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_autocharge_automation`,
      {
        bottle_cycle: {
          bottle_autofill_automation_attributes: {
            id: templateAutofill.value?.id,
            automation_fields_attributes: [
              {
                id: autofillFields.value.find(x => x.attributes.key === 'type')?.id,
                key: 'type',
                text_value: local.template.autofill
              }
            ]
          }
        }
      }
    )
  }
  if (local.pass.enabled && local.pass.id) {
    const formattedRewards = local.pass.rewards
      .map(reward => {
        const baseReward = reward.id ? { id: reward.id } : {}
        switch (reward.type) {
          case 'Immediate':
            return {
              ...baseReward,
              type: 'ImmediateMembershipPassReward',
              credit_amount_cents: Math.round(reward.amount * 100)
            }
          case 'Credit': {
            const rewardData = {
              ...baseReward,
              type: 'AccountCreditMembershipPassReward',
              credit_amount_cents: Math.round(reward.amount * 100),
              credit_interval: reward.interval.type,
              auto_apply: reward.autoApply
            }
            if (reward.interval.type === 'monthly') {
              rewardData.credit_award_date = parseInt(reward.interval.dayOfMonth)
            } else {
              const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
              rewardData.credit_award_day = days[reward.interval.dayOfWeek]
            }
            if (reward.expiryEnabled) {
              rewardData.expiry_value = reward.expiry.number
              rewardData.expiry_type = reward.expiry.string.slice(0, -1)
            } else {
              rewardData.expiry_value = null
              rewardData.expiry_type = null
            }
            return rewardData
          }
          case 'Delivery':
            return { ...baseReward, type: 'FulfillmentMembershipPassReward' }
          default:
            return null
        }
      })
      .filter(Boolean)

    try {
      await api.call('PUT', `membership_passes/${local.pass.id}?included=membership_pass_rewards,membership_tiers`, {
        membership_pass: {
          name: local.pass.name,
          description: local.pass.description,
          price_cents: Math.round(local.pass.billingPrice * 100),
          billing_interval: local.pass.billingInterval,
          auto_select: local.pass.autoSelect,
          membership_pass_rewards_attributes: formattedRewards
        }
      })
    } catch (error) {
      console.error('Error saving pass:', error)
      showToast('Failed to save pass', { type: 'error' })
    }
  }

  hasUnsavedChanges.value = false
}

const storeWaiting = computed(() =>
  Object.keys(waiting)
    .filter(x => x.startsWith('store-'))
    .some(x => waiting[x])
)
const storeActive = store => {
  const pairs = mapRelationships(tier.value?.relationships.membership_tier_store_pairs.data)
  return pairs.some(x => x.attributes.store_id == store.id) != Boolean(waiting['store-' + store.id])
}
const toggleStore = async store => {
  const pairs = mapRelationships(tier.value?.relationships.membership_tier_store_pairs.data)
  let sendablePairs = pairs.map(x => ({ store_id: x.attributes.store_id }))

  if (sendablePairs.some(x => x.store_id == store.id)) {
    sendablePairs = sendablePairs.filter(x => x.store_id != store.id)
  } else {
    sendablePairs.push({ store_id: store.id })
  }

  waiting['store-' + store.id] = true
  await api.call('PUT', `membership_tiers/${route.params.id}?included=membership_tier_store_pairs`, {
    membership_tier: {
      membership_tier_store_pairs_attributes: sendablePairs
    }
  })
  waiting['store-' + store.id] = false
}

const weekdayOptions = [
  { name: 'Monday', value: 'monday' },
  { name: 'Tuesday', value: 'tuesday' },
  { name: 'Wednesday', value: 'wednesday' },
  { name: 'Thursday', value: 'thursday' },
  { name: 'Friday', value: 'friday' },
  { name: 'Saturday', value: 'saturday' },
  { name: 'Sunday', value: 'sunday' }
]

const mealPlanStoreIds = computed(() => {
  // Categories can come from any of the tier's paired stores; a tier with no
  // pairs yet falls back to all of the merchant's stores. A single-store guess
  // is wrong for multi-store merchants (the first store may only hold the
  // auto-created Upsells Category, which is filtered out below).
  const pairedIds = mapRelationships(tier.value?.relationships?.membership_tier_store_pairs?.data)
    .map(pair => pair.attributes?.store_id)
    .filter(id => id != null)
  const ids = pairedIds.length ? pairedIds : (stores.value || []).map(store => parseInt(store.id))
  return [...new Set(ids)]
})

const fetchedCategoryStoreIds = new Set()
watch(
  () => (local.mealPlan.enabled ? mealPlanStoreIds.value : []),
  storeIds => {
    storeIds.forEach(storeId => {
      if (fetchedCategoryStoreIds.has(storeId)) return
      fetchedCategoryStoreIds.add(storeId)
      api.call('GET', `stores/${storeId}/categories?included=none`)
    })
  },
  { immediate: true }
)

const categoryOptions = computed(() => {
  const contributingStores = mealPlanStoreIds.value
    .map(storeId => mapRelationship({ type: 'store', id: storeId }))
    .filter(store => store)
  const labelWithStore = contributingStores.length > 1
  return contributingStores.flatMap(store =>
    mapRelationships(store.relationships?.categories?.data)
      .filter(x => x.attributes.type !== 'UpsellCategory')
      .map(x => ({
        name: labelWithStore
          ? `${x.attributes.category_name} (${store.attributes.store_name})`
          : x.attributes.category_name,
        value: parseInt(x.id)
      }))
  )
})

const rolloverOptions = computed(() => [
  { name: 'Expire each week', value: 'week' },
  { name: 'Roll over for a month', value: 'month' },
  { name: 'Never expire', value: 'never' },
  ...(local.mealPlan.rollover === 'custom' ? [{ name: 'Custom (current setting)', value: 'custom' }] : [])
])

const subscriptionSettings = computed(() => mapRelationships(tier.value?.relationships.cart_subscription_settings.data))
const cartSubscriptionEnabled = computed(
  () => tier.value?.attributes.has_cart_subscription_attached != Boolean(waiting.cartSubscription)
)
const setCartSubscription = async enable => {
  waiting.cartSubscription = true
  await api.call(
    'PUT',
    `membership_tiers/${route.params.id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings`,
    {
      membership_tier: {
        has_cart_subscription_attached: enable
      }
    }
  )
  waiting.cartSubscription = false
}

const autochargeEnabled = computed(
  () =>
    (subscriptionSettings.value.find(x => x.attributes.setting_name === 'autocharge')?.attributes
      .setting_string_value ===
      'always') !=
    Boolean(waiting.autocharge)
)
const setAutocharge = async enable => {
  const autocharge = subscriptionSettings.value.find(x => x.attributes.setting_name === 'autocharge')
  waiting.autocharge = true
  await api.call(
    'PUT',
    `membership_tiers/${route.params.id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings`,
    {
      membership_tier: {
        cart_subscription_settings_attributes: [
          { setting_name: 'autocharge', setting_string_value: enable ? 'always' : 'never', id: autocharge?.id }
        ]
      }
    }
  )
  waiting.autocharge = false
}

const intervals = computed(() =>
  subscriptionSettings.value.filter(x => x.attributes.setting_name === 'interval').sort((a, b) => a.id - b.id)
)
const addInterval = async () => {
  await api.call(
    'PUT',
    `membership_tiers/${route.params.id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings`,
    {
      membership_tier: {
        cart_subscription_settings_attributes: [
          { setting_name: 'interval' /* , setting_string_value: '', setting_integer_value: 0  */ }
        ]
      }
    }
  )
  for (const interval of intervals.value) {
    local.cartSubscription.intervals[interval.id] = {
      string: interval.attributes.setting_string_value ?? 'days',
      number: interval.attributes.setting_integer_value
    }
  }
}
const deleteInterval = interval => {
  api.call(
    'PUT',
    `membership_tiers/${route.params.id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings`,
    {
      membership_tier: {
        cart_subscription_settings_attributes: [{ id: interval.id, _destroy: true }]
      }
    }
  )
}

const storeSettings = computed(() => subscriptionSettings.value.filter(x => x.attributes.setting_name === 'store'))

const subscriptionStoreActive = store =>
  subscriptionSettings.value
    .filter(x => x.attributes.setting_name === 'store')
    .some(x => x.attributes.setting_integer_value == store.id) != Boolean(waiting['subscription-store-' + store.id])
const subscriptionToggleStore = async store => {
  const setting = subscriptionSettings.value
    .filter(x => x.attributes.setting_name === 'store')
    .find(x => x.attributes.setting_integer_value == store.id)

  waiting['subscription-store-' + store.id] = true
  if (setting) {
    await api.call(
      'PUT',
      `membership_tiers/${route.params.id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings`,
      {
        membership_tier: {
          cart_subscription_settings_attributes: [{ id: setting.id, _destroy: true }]
        }
      }
    )
  } else {
    await api.call(
      'PUT',
      `membership_tiers/${route.params.id}?included=membership_tier_store_pairs,user,user.stores,cart_subscription_settings`,
      {
        membership_tier: {
          cart_subscription_settings_attributes: [{ setting_name: 'store', setting_integer_value: store.id }]
        }
      }
    )
  }
  waiting['subscription-store-' + store.id] = false
  local.cartSubscription.defaultStore =
    storeSettings.value.find(x => x.attributes.is_default)?.attributes.setting_integer_value.toString() ?? null
}

const loadMembershipFees = () => {
  const relationships = tier.value?.relationships
  local.membershipFee.oneTime = oneTimeFeeFromServer(mapRelationship(relationships?.one_time_membership_fee?.data))
  local.membershipFee.recurring = recurringFeeFromServer(mapRelationship(relationships?.recurring_membership_fee?.data))
}

const setMembershipFeeAmount = (feeKey, value) => {
  local.membershipFee[feeKey].flat_rate_cents = Math.round(parseFloat(value || 0) * 100)
  hasUnsavedChanges.value = true
}

// The tier response can still reference a fee it has just destroyed, so drop
// it from the store ourselves or it reappears as enabled on the next discard.
const forgetStoredFee = relationshipName => {
  const fee = mapRelationship(tier.value?.relationships[relationshipName]?.data)
  if (fee) store.commit('DESTROY_OBJECT', { data: fee })
}

// Keep the ids of newly created fees so the next save updates them instead of
// creating duplicates, and clear the state of fees that were just removed.
const syncMembershipFeeIds = response => {
  const relationships = response.data?.data?.relationships ?? {}
  const { oneTime, recurring } = local.membershipFee

  if (oneTime.enabled) {
    oneTime.id = relationships.one_time_membership_fee?.data?.id ?? oneTime.id
  } else {
    forgetStoredFee('one_time_membership_fee')
    local.membershipFee.oneTime = blankOneTimeFee()
  }

  if (recurring.enabled) {
    recurring.id = relationships.recurring_membership_fee?.data?.id ?? recurring.id
  } else {
    forgetStoredFee('recurring_membership_fee')
    local.membershipFee.recurring = blankRecurringFee()
  }
}

const setPasses = async enable => {
  waiting.passes = true
  try {
    if (enable) {
      if (local.pass.id) {
        const response = await api.call(
          'PUT',
          `membership_passes/${local.pass.id}?included=membership_pass_rewards,membership_tiers,membership_tier_membership_pass_pairs`,
          {
            membership_pass: {
              membership_tier_membership_pass_pairs_attributes: [{ membership_tier_id: route.params.id }]
            }
          }
        )
        const newPair = response.data.included?.find(
          x =>
            x.type === 'membership_tier_membership_pass_pair' &&
            String(x.attributes.membership_tier_id) === String(route.params.id)
        )
        local.pass.pairId = newPair?.id ?? null
        await api.call(
          'GET',
          `membership_tiers/${route.params.id}?included=membership_tier_membership_pass_pair,membership_pass`
        )
      } else {
        const response = await api.call(
          'POST',
          'membership_passes?included=membership_pass_rewards,membership_tiers,membership_tier_membership_pass_pairs',
          {
            membership_pass: {
              name: '',
              description: '',
              price_cents: 0,
              billing_interval: 'weekly',
              auto_select: false,
              membership_tier_membership_pass_pairs_attributes: [{ membership_tier_id: route.params.id }]
            }
          }
        )
        const created = response.data.data
        local.pass.id = created.id
        local.pass.name = created.attributes.name ?? ''
        local.pass.description = created.attributes.description ?? ''
        local.pass.billingPrice = (created.attributes.price_cents ?? 0) / 100
        local.pass.billingInterval = created.attributes.billing_interval ?? 'weekly'
        local.pass.autoSelect = Boolean(created.attributes.auto_select)
        local.pass.rewards = []
        local.pass.sharedTierCount = 1
        const pairRef = created.relationships.membership_tier_membership_pass_pairs?.data?.[0]
        local.pass.pairId = pairRef?.id ?? null
        // Refresh the tier so its has_one :membership_pass is populated for future loads.
        await api.call(
          'GET',
          `membership_tiers/${route.params.id}?included=membership_tier_membership_pass_pair,membership_pass`
        )
      }
      local.pass.enabled = true
    } else {
      if (local.pass.id && local.pass.pairId) {
        await api.call(
          'PUT',
          `membership_passes/${local.pass.id}?included=membership_tier_membership_pass_pairs,membership_tiers`,
          {
            membership_pass: {
              membership_tier_membership_pass_pairs_attributes: [{ id: local.pass.pairId, _destroy: true }]
            }
          }
        )
      }
      local.pass.enabled = false
      local.pass.pairId = null
      // Keep local.pass.id so a re-toggle-on within this session re-pairs the same pass.
      await api.call(
        'GET',
        `membership_tiers/${route.params.id}?included=membership_tier_membership_pass_pair,membership_pass`
      )
    }
  } catch (error) {
    console.error('Error toggling passes:', error)
    showToast('Failed to toggle passes', { type: 'error' })
  } finally {
    waiting.passes = false
  }
}

const template = computed(() => mapRelationship(tier.value?.relationships.bottle_cycle_templates.data?.[0]))

const templateAutocharge = computed(() =>
  mapRelationship(template.value?.relationships.bottle_autocharge_automation.data)
)
const templateAutochargeEnabled = computed(
  () => Boolean(templateAutocharge.value) != Boolean(waiting.templateAutocharge)
)
const setTemplateAutocharge = async enable => {
  waiting.templateAutocharge = true
  if (enable) {
    await api.call(
      'PUT',
      `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_autocharge_automation`,
      {
        bottle_cycle: {
          bottle_autocharge_automation_attributes: {
            offset_type: 'minutes',
            offset_value: 0
          }
        }
      }
    )
    local.template.autocharge.string = templateAutocharge.value.attributes.offset_type
    local.template.autocharge.number = Math.abs(templateAutocharge.value.attributes.offset_value)
    local.template.autocharge.multiplier = templateAutocharge.value.attributes.offset_value < 0 ? -1 : 1
  } else {
    await api.call(
      'PUT',
      `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_autocharge_automation`,
      {
        bottle_cycle: {
          bottle_autocharge_automation_attributes: {
            id: templateAutocharge.value.id,
            _destroy: true
          }
        }
      }
    )
  }
  waiting.templateAutocharge = false
}

const templateAutofill = computed(() => mapRelationship(template.value?.relationships.bottle_autofill_automation.data))
const autofillFields = computed(() => mapRelationships(templateAutofill.value?.relationships.automation_fields.data))
const runBeforeEnabled = computed(
  () => before =>
    autofillFields.value.some(x => x.attributes.key === 'run_before' && x.attributes.text_value === before) !=
    Boolean(waiting['before-' + before])
)
const setRunBefore = async (before, enable) => {
  waiting['before-' + before] = true
  if (enable) {
    await api.call(
      'PUT',
      `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_autofill_automation,bottle_autofill_automation.automation_fields`,
      {
        bottle_cycle: {
          bottle_autofill_automation_attributes: {
            id: templateAutofill.value?.id,
            automation_fields_attributes: [
              {
                key: 'run_before',
                text_value: before
              }
            ]
          }
        }
      }
    )
  } else {
    await api.call(
      'PUT',
      `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_autofill_automation,bottle_autofill_automation.automation_fields`,
      {
        bottle_cycle: {
          bottle_autofill_automation_attributes: {
            id: templateAutofill.value?.id,
            automation_fields_attributes: autofillFields.value
              .filter(x => x.attributes.key === 'run_before' && x.attributes.text_value === before)
              .map(x => ({ _destroy: true, id: x.id }))
          }
        }
      }
    )
  }
  waiting['before-' + before] = false
}

const reminders = computed(() => mapRelationships(template.value.relationships.bottle_reminder_automations.data))
const reminderTemplate = reminder => mapRelationship(reminder.relationships.message_template.data)
const addReminder = async () => {
  await api.call(
    'PUT',
    `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_reminder_automations,bottle_reminder_automations.message_template`,
    {
      bottle_cycle: {
        bottle_reminder_automations_attributes: [
          {
            offset_type: 'minutes',
            offset_value: 0,
            message_template_attributes: { body: 'Reminder text goes here.' }
          }
        ]
      }
    }
  )
  openModal(reminders.value.at(-1), true)
}
const deleteReminder = async reminder => {
  await api.call(
    'PUT',
    `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_reminder_automations`,
    { bottle_cycle: { bottle_reminder_automations_attributes: [{ _destroy: true, id: reminder.id }] } }
  )
}
const reminderFormat = reminder => {
  let value = reminder.attributes.offset_value
  if (reminder.attributes.offset_type === 'hours') value *= 60
  if (reminder.attributes.offset_type === 'days') value *= 60 * 24
  const days = Math.floor(value / (60 * 24))
  const multiplier = Math.sign(days)
  const absdays = Math.abs(days)
  const minutes = value - 60 * 24 * days
  let string = ''
  let hours = Math.floor(minutes / 60) % 12
  if (hours === 0) hours = 12
  string += hours
  string += ':'
  string += String(minutes % 60).padStart(2, 0)
  string += Math.floor(minutes / 60) >= 12 ? ' PM' : ' AM'
  string += ', '
  if (multiplier === 0) string += 'day of'
  if (multiplier !== 0) string += absdays + ' days '
  if (multiplier === 1) string += 'after'
  if (multiplier === -1) string += 'before'
  if (multiplier !== 0) string += ' the production day'
  return string
}
const openModal = (reminder, nu) => {
  modal.reminder = reminder
  modal.new = Boolean(nu)
  modal.open = true
  if (modal.new) {
    modal.multiplier = 0
    modal.days = ''
    modal.time = '00:00'
    modal.body = ''
  } else {
    let value = reminder.attributes.offset_value
    if (reminder.attributes.offset_type === 'hours') value *= 60
    if (reminder.attributes.offset_type === 'days') value *= 60 * 24
    const days = Math.floor(value / (60 * 24))
    modal.multiplier = Math.sign(days)
    modal.days = Math.abs(days)
    const minutes = value - 60 * 24 * modal.days * modal.multiplier
    modal.time = String(Math.floor(minutes / 60)).padStart(2, 0) + ':' + String(minutes % 60).padStart(2, 0)
    modal.body = mapRelationship(reminder.relationships.message_template.data).attributes.body
  }
}
const closeModal = () => {
  if (modal.new) deleteReminder(modal.reminder)
  modal.open = false
}
const saveModal = () => {
  const hours = Number(modal.time.split(':')[0])
  const minutes = Number(modal.time.split(':')[1])
  api.call(
    'PUT',
    `membership_tiers/${route.params.id}/bottle_cycle_templates/${template.value.id}?included=bottle_reminder_automations,bottle_reminder_automations.message_template`,
    {
      bottle_cycle: {
        bottle_reminder_automations_attributes: [
          {
            id: modal.reminder.id,
            offset_type: 'minutes',
            offset_value: (modal.days ?? 0) * 60 * 24 * modal.multiplier + hours * 60 + minutes,
            message_template_attributes: { body: modal.body }
          }
        ]
      }
    }
  )
  modal.open = false
}

const deleteTier = () => {
  if (!confirm(`Delete ${local.name}?`)) return
  api.call('DELETE', `membership_tiers/${route.params.id}`).then(() => {
    hasUnsavedChanges.value = false
    router.push('/store/membership-tiers')
  })
}

const moveMembers = () => {
  if (!local.moveTier) return
  api.call('POST', `membership_tiers/${route.params.id}/move?move_to_id=${local.moveTier}`)
  local.membersMoved = true
}

const openUpgradeModal = () => {
  upgradeModal.id = null
  upgradeModal.open = true
}

const saveUpgradeModal = async () => {
  upgradeModal.open = false
  await api.call('PUT', `membership_tiers/${upgradeModal.id}?included=none`, {
    membership_tier: {
      upgrade_for_membership_tier_id: route.params.id
    }
  })
  api.call('GET', `membership_tiers/${route.params.id}?included=one_time_membership_fee,recurring_membership_fee`)
}

const deleteUpgrade = async upgrade => {
  await api.call('PUT', `membership_tiers/${upgrade.id}?included=none`, {
    membership_tier: {
      upgrade_for_membership_tier_id: null
    }
  })
  api.call('GET', `membership_tiers/${route.params.id}?included=one_time_membership_fee,recurring_membership_fee`)
}

// ---- Pass / rewards helpers ----

const getDayOfMonthSuffix = day => {
  if (day >= 11 && day <= 13) return 'th'
  switch (day % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

const mapImmediateReward = (reward, baseReward) => ({
  ...baseReward,
  type: 'Immediate',
  amount: reward.attributes.credit_amount_cents / 100
})

const mapCreditReward = (reward, baseReward) => {
  const dayOfWeek =
    reward.attributes.credit_award_day &&
    ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'].indexOf(
      reward.attributes.credit_award_day
    )

  return {
    ...baseReward,
    type: 'Credit',
    amount: reward.attributes.credit_amount_cents / 100,
    interval: {
      type: reward.attributes.credit_interval,
      dayOfWeek: dayOfWeek >= 0 ? dayOfWeek : 0,
      dayOfMonth:
        reward.attributes.credit_interval === 'monthly'
          ? reward.attributes.credit_award_date
          : reward.attributes.credit_award_day
    },
    autoApply: Boolean(reward.attributes.auto_apply),
    expiryEnabled: Boolean(reward.attributes.expiry_value),
    expiry: reward.attributes.expiry_value
      ? { number: reward.attributes.expiry_value, string: `${reward.attributes.expiry_type}s` }
      : { number: 1, string: 'weeks' }
  }
}

const mapDeliveryReward = baseReward => ({ ...baseReward, type: 'Delivery' })

const mapPassReward = rewardRef => {
  const reward = mapRelationship(rewardRef)
  if (!reward) return null
  const baseReward = { id: reward.id }
  const mappers = {
    ImmediateMembershipPassReward: () => mapImmediateReward(reward, baseReward),
    AccountCreditMembershipPassReward: () => mapCreditReward(reward, baseReward),
    FulfillmentMembershipPassReward: () => mapDeliveryReward(baseReward)
  }
  const mapper = mappers[reward.attributes.type]
  return mapper ? mapper() : null
}

const rewardFormat = reward => {
  switch (reward.type) {
    case 'Immediate':
      return `Immediate discount: $${reward.amount} off on signup`
    case 'Credit': {
      const intervalText = {
        weekly: `Weekly on ${['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][reward.interval.dayOfWeek]}s`,
        every_two_weeks: `Every 2 weeks on ${['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][reward.interval.dayOfWeek]}s`,
        monthly: `Monthly on the ${reward.interval.dayOfMonth}${getDayOfMonthSuffix(reward.interval.dayOfMonth)}`
      }[reward.interval.type]
      const expiryText = reward.expiryEnabled
        ? ` (expires ${reward.expiry.number} ${parseInt(reward.expiry.number) === 1 ? reward.expiry.string.slice(0, -1) : reward.expiry.string} after being issued)`
        : ''
      return `Account credit: $${reward.amount} ${intervalText}${reward.autoApply ? ' (auto-applied at checkout)' : ''}${expiryText}`
    }
    case 'Delivery':
      return 'Free delivery / shipping on all orders'
    default:
      return 'Unknown reward type'
  }
}

const addReward = () => {
  rewardsModal.mode = 'add'
  rewardsModal.type = ''
  rewardsModal.reward = null
  rewardsModal.immediateAmount = 0
  rewardsModal.creditAmount = 0
  rewardsModal.creditInterval = { type: 'weekly', dayOfWeek: 0, dayOfMonth: 1 }
  rewardsModal.creditAutoApply = false
  rewardsModal.creditExpiryEnabled = false
  rewardsModal.creditExpiry = { number: 1, string: 'weeks' }
  rewardsModal.open = true
}

const editReward = reward => {
  rewardsModal.mode = 'edit'
  rewardsModal.reward = reward
  rewardsModal.type = reward.type
  switch (reward.type) {
    case 'Immediate':
      rewardsModal.immediateAmount = reward.amount
      break
    case 'Credit':
      rewardsModal.creditAmount = reward.amount
      rewardsModal.creditInterval = reward.interval
      rewardsModal.creditAutoApply = reward.autoApply
      rewardsModal.creditExpiryEnabled = reward.expiryEnabled
      rewardsModal.creditExpiry = reward.expiry
      break
  }
  rewardsModal.open = true
}

const deleteReward = async reward => {
  if (!confirm('Are you sure you want to delete this reward?')) return
  try {
    if (reward.id && local.pass.id) {
      await api.call('PUT', `membership_passes/${local.pass.id}`, {
        membership_pass: {
          membership_pass_rewards_attributes: [{ id: reward.id, _destroy: true }]
        }
      })
    }
    const index = local.pass.rewards.findIndex(r => r.id === reward.id)
    if (index !== -1) {
      local.pass.rewards.splice(index, 1)
      if (!reward.id) hasUnsavedChanges.value = true
    }
  } catch (error) {
    console.error('Error deleting reward:', error)
    showToast('Failed to delete reward', { type: 'error' })
  }
}

const closeRewardsModal = () => {
  rewardsModal.open = false
}

const saveRewardsModal = () => {
  if (rewardsModal.mode === 'edit') {
    const rewardIndex = local.pass.rewards.findIndex(r => r.id === rewardsModal.reward.id)
    if (rewardIndex !== -1) {
      local.pass.rewards[rewardIndex] = {
        id: rewardsModal.reward.id,
        type: rewardsModal.type,
        amount: rewardsModal.type === 'Immediate' ? rewardsModal.immediateAmount : rewardsModal.creditAmount,
        interval: rewardsModal.creditInterval,
        autoApply: rewardsModal.creditAutoApply,
        expiryEnabled: rewardsModal.creditExpiryEnabled,
        expiry: rewardsModal.creditExpiry
      }
    }
  } else {
    const newReward = {
      type: rewardsModal.type,
      amount: rewardsModal.type === 'Immediate' ? rewardsModal.immediateAmount : rewardsModal.creditAmount
    }
    if (rewardsModal.type === 'Credit') {
      newReward.interval = rewardsModal.creditInterval
      newReward.autoApply = rewardsModal.creditAutoApply
      newReward.expiryEnabled = rewardsModal.creditExpiryEnabled
      newReward.expiry = rewardsModal.creditExpiry
    }
    local.pass.rewards.push(newReward)
  }
  hasUnsavedChanges.value = true
  rewardsModal.open = false
}

const shouldHideRewardsSaveButton = computed(() => {
  if (!rewardsModal.type) return false
  switch (rewardsModal.type) {
    case 'Immediate':
      return rewardsModal.immediateAmount <= 0
    case 'Credit':
      return rewardsModal.creditAmount <= 0
    case 'Delivery':
      return false
    default:
      return false
  }
})

return (_ctx, _cache) => {
  const _component_InputField = _resolveComponent("InputField")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheModal, {
      "is-open": modal.open,
      "modal-title": modal.new ? 'Add reminder' : 'Edit reminder',
      "max-width": "max-w-2xl",
      onCloseModal: closeModal
    }, {
      main: _withCtx(() => [
        _createVNode(_component_FormSection, { fullwidth: true }, {
          default: _withCtx(() => [
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _cache[73] || (_cache[73] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Reminder time", -1)),
                _createElementVNode("div", _hoisted_1, [
                  _cache[72] || (_cache[72] = _createTextVNode(" At ", -1)),
                  _createVNode(_component_InputField, {
                    modelValue: modal.time,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((modal.time) = $event)),
                    type: "time",
                    class: "w-32"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_SelectInput, {
                    modelValue: modal.multiplier,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((modal.multiplier) = $event)),
                    options: [
                { name: 'this many days before the production day:', value: -1 },
                { name: 'on the day of production', value: 0 },
                { name: 'this many days after the production day:', value: 1 }
              ]
                  }, null, 8, ["modelValue"]),
                  (modal.multiplier != 0)
                    ? (_openBlock(), _createBlock(_component_InputField, {
                        key: 0,
                        modelValue: modal.days,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.days) = $event)),
                        class: "w-16"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _createVNode(_component_InputArea, {
                  modelValue: modal.body,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.body) = $event)),
                  name: "Reminder text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_NeueButton, {
          type: "secondary",
          onClick: closeModal
        }, {
          default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_NeueButton, {
          type: modal.body ? 'primary' : 'inactive',
          onClick: saveModal
        }, {
          default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"]),
    _createVNode(_component_TheModal, {
      "is-open": upgradeModal.open,
      "modal-title": "Add upgrade",
      onCloseModal: _cache[6] || (_cache[6] = $event => (upgradeModal.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_component_FormSection, null, {
          default: _withCtx(() => [
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _createVNode(_component_SelectInput, {
                  modelValue: upgradeModal.id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((upgradeModal.id) = $event)),
                  placeholder: "Select membership tier",
                  options: 
              tiers.value
                .filter(x => x.id != tier.value.id && !upgrades.value.some(y => y.id === x.id))
                .map(x => ({ name: x.attributes.tier_name, value: x.id }))
            
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_NeueButton, {
          type: "secondary",
          onClick: _cache[5] || (_cache[5] = $event => (upgradeModal.open = false))
        }, {
          default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_NeueButton, {
          type: upgradeModal.id ? 'primary' : 'inactive',
          onClick: saveUpgradeModal
        }, {
          default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_TheModal, {
      "is-open": rewardsModal.open,
      "modal-title": rewardsModal.mode === 'add' ? 'Add reward' : 'Edit reward',
      "max-width": "max-w-2xl",
      onCloseModal: closeRewardsModal
    }, {
      main: _withCtx(() => [
        _createVNode(_component_FormSection, { fullwidth: true }, {
          default: _withCtx(() => [
            _createVNode(_component_FormElement, null, {
              default: _withCtx(() => [
                _createVNode(_component_SelectInput, {
                  name: "Reward type",
                  placeholder: "Please select",
                  "model-value": rewardsModal.type || null,
                  options: [
              { name: 'Immediate discount', value: 'Immediate' },
              { name: 'Account credit', value: 'Credit' },
              { name: 'Free delivery / shipping', value: 'Delivery' }
            ],
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = value => (rewardsModal.type = value))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }),
            (rewardsModal.type === 'Immediate')
              ? (_openBlock(), _createBlock(_component_FormElement, { key: 0 }, {
                  default: _withCtx(() => [
                    _cache[78] || (_cache[78] = _createElementVNode("div", { class: "text-sm text-gray-600 mb-4" }, " Give an immediate discount on the customer's current order when they sign up for this pass. This encourages immediate adoption of the pass program. ", -1)),
                    _createVNode(_component_InputField, {
                      modelValue: rewardsModal.immediateAmount,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((rewardsModal.immediateAmount) = $event)),
                      name: "Amount off",
                      prefix: "$",
                      type: "number",
                      class: "w-2/5",
                      restrict: "monetary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (rewardsModal.type === 'Credit')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "text-sm text-gray-600 mb-4" }, " Automatically credit the customer's account with a specified amount at regular intervals. This credit can be used towards future purchases. ", -1)),
                      _createVNode(_component_InputField, {
                        modelValue: rewardsModal.creditAmount,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((rewardsModal.creditAmount) = $event)),
                        name: "Credit amount",
                        prefix: "$",
                        type: "number",
                        class: "w-2/5",
                        restrict: "monetary"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _cache[80] || (_cache[80] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Credit interval", -1)),
                      _createVNode(_component_SelectInput, {
                        modelValue: rewardsModal.creditInterval.type,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((rewardsModal.creditInterval.type) = $event)),
                        options: [
                { name: 'Weekly', value: 'weekly' },
                { name: 'Every 2 weeks', value: 'every_two_weeks' },
                { name: 'Monthly', value: 'monthly' }
              ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (
              rewardsModal.creditInterval.type === 'weekly' || rewardsModal.creditInterval.type === 'every_two_weeks'
            )
                    ? (_openBlock(), _createBlock(_component_FormElement, { key: 0 }, {
                        default: _withCtx(() => [
                          _cache[81] || (_cache[81] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Day of week account credit is given", -1)),
                          _createElementVNode("div", _hoisted_2, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['S', 'M', 'T', 'W', 'T', 'F', 'S'], (day, index) => {
                              return _createElementVNode("div", {
                                key: index,
                                class: _normalizeClass([
                  rewardsModal.creditInterval.dayOfWeek === index ? 'bg-green-500' : 'bg-gray-600 hover:bg-green-600',
                  'w-10 h-10 rounded-full text-white inline-flex justify-center items-center cursor-pointer'
                ]),
                                onClick: $event => (rewardsModal.creditInterval.dayOfWeek = index)
                              }, _toDisplayString(day), 11, _hoisted_3)
                            }), 64))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (rewardsModal.creditInterval.type === 'monthly')
                    ? (_openBlock(), _createBlock(_component_FormElement, { key: 1 }, {
                        default: _withCtx(() => [
                          _cache[82] || (_cache[82] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Day of month account credit is given", -1)),
                          _createVNode(_component_SelectInput, {
                            modelValue: rewardsModal.creditInterval.dayOfMonth,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((rewardsModal.creditInterval.dayOfMonth) = $event)),
                            options: 
                Array.from({ length: 31 }, (_, i) => i + 1).map(day => ({
                  name: `${day}${getDayOfMonthSuffix(day)}`,
                  value: day
                }))
              
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueToggle, {
                        modelValue: rewardsModal.creditAutoApply,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((rewardsModal.creditAutoApply) = $event)),
                        name: "Auto apply the reward at checkout",
                        description: "Automatically apply this credit to the customer's order at checkout"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormElement, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueToggle, {
                        modelValue: rewardsModal.creditExpiryEnabled,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((rewardsModal.creditExpiryEnabled) = $event)),
                        name: "Enable expiry",
                        description: "Set whether the credited amount should expire after a certain time"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (rewardsModal.creditExpiryEnabled)
                    ? (_openBlock(), _createBlock(_component_FormElement, { key: 2 }, {
                        default: _withCtx(() => [
                          _cache[83] || (_cache[83] = _createElementVNode("div", { class: "text-sm font-medium text-gray-700 mb-1" }, "Expires in", -1)),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_InputField, {
                              modelValue: rewardsModal.creditExpiry.number,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((rewardsModal.creditExpiry.number) = $event)),
                              class: "w-16",
                              type: "number"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_SelectInput, {
                              modelValue: rewardsModal.creditExpiry.string,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((rewardsModal.creditExpiry.string) = $event)),
                              options: 
                  ['days', 'weeks', 'months', 'years'].map(x => ({
                    name: rewardsModal.creditExpiry.number == 1 ? x.slice(0, -1) : x,
                    value: x
                  }))
                
                            }, null, 8, ["modelValue", "options"])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (rewardsModal.type === 'Delivery')
              ? (_openBlock(), _createBlock(_component_FormElement, { key: 2 }, {
                  default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                    _createElementVNode("div", { class: "text-sm text-gray-600 mb-4" }, " Offer free delivery and shipping on all orders while the customer has an active pass. This eliminates delivery costs as a barrier to purchase and can significantly increase order frequency. ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_NeueButton, {
          type: "secondary",
          onClick: closeRewardsModal
        }, {
          default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        (!shouldHideRewardsSaveButton.value)
          ? (_openBlock(), _createBlock(_component_NeueButton, {
              key: 0,
              type: rewardsModal.type ? 'primary' : 'inactive',
              onClick: saveRewardsModal
            }, {
              default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                _createTextVNode(" Save ", -1)
              ]))]),
              _: 1
            }, 8, ["type"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"]),
    _createVNode(_component_TheModal, {
      "is-open": leaveModal.value,
      "modal-title": "Leave without saving?",
      "modal-description": "Your changes to this membership tier will be lost.",
      onCloseModal: _cache[17] || (_cache[17] = $event => (leaveModal.value = false))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_NeueButton, {
          type: "secondary",
          onClick: _cache[16] || (_cache[16] = $event => (leaveModal.value = false))
        }, {
          default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
            _createTextVNode("Keep editing", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_NeueButton, {
          type: "red",
          onClick: confirmLeave
        }, {
          default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
            _createTextVNode("Leave without saving", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_SecondaryNav, null, {
      top: _withCtx(() => [
        _createVNode(_component_SecondaryTop, {
          "save-status": true,
          parent: _unref(backLink),
          text: local.name,
          sections: _unref(tierSections),
          actions: 
          isMobileViewport() && [
            {
              name: 'View tier',
              icon: _unref(UserGroupIcon),
              action: () => _unref(router).push(_unref(tierViewPath)(_unref(route).params.id))
            }
          ]
        
        }, {
          right: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: _unref(tierViewPath)(_unref(route).params.id),
              class: "hidden sm:block"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_NeueButton, { type: "secondary" }, {
                  default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                    _createTextVNode("View tier", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["parent", "text", "sections", "actions"]),
        _createVNode(_component_SaveBar, {
          "has-unsaved-changes": hasUnsavedChanges.value,
          parent: _unref(backLink),
          onOnDiscard: discard,
          onOnSave: save
        }, null, 8, ["has-unsaved-changes", "parent"])
      ]),
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NeueLoading, { loading: loading.value }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_7, [
                  _createVNode(SettingsSection, {
                    title: "Details",
                    description: "How this tier is named and described to customers.",
                    onInput: _cache[20] || (_cache[20] = $event => (hasUnsavedChanges.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputField, {
                        modelValue: local.name,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((local.name) = $event)),
                        name: "Name"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputArea, {
                        modelValue: local.description,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((local.description) = $event)),
                        name: "Description"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(SettingsSection, {
                    title: "Default tier",
                    description: "The tier customers are placed on when they have not joined another one.",
                    flush: ""
                  }, {
                    default: _withCtx(() => [
                      _cache[90] || (_cache[90] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Make this the default tier"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Only one tier can be the default, so this replaces the current one. ")
                      ], -1)),
                      _createVNode(_component_NeueToggle, {
                        modelValue: local.default,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((local.default) = $event)),
                        onChange: _cache[22] || (_cache[22] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(SettingsSection, {
                    title: "Stores",
                    description: "The stores that offer this tier as an option at checkout."
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stores.value, (store) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: store.id,
                          to: '/store/stores/' + store.id,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NeueToggle, {
                              "model-value": storeActive(store),
                              name: store.attributes.store_name,
                              description: store.attributes.store_description,
                              disabled: storeWaiting.value,
                              "onUpdate:modelValue": $event => (toggleStore(store))
                            }, null, 8, ["model-value", "name", "description", "disabled", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _unref(activeTab) === 'main']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                  _createVNode(SettingsSection, {
                    title: "Upgrades",
                    description: "The tiers members can upgrade to from this one.",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      (upgrades.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_unref(NeueTablist), null, {
                              head: _withCtx(() => [
                                _createVNode(_unref(TablistHeader), null, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, {
                                      columns: ['Upgrades', ''],
                                      header: "",
                                      class: "items-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[92] || (_cache[92] = _createElementVNode("div", null, "Upgrades", -1)),
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_component_NeueButton, {
                                            type: "secondary",
                                            onClick: openUpgradeModal
                                          }, {
                                            default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                              _createTextVNode("+ Upgrade", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upgrades.value, (upgrade) => {
                                  return (_openBlock(), _createBlock(_unref(TablistRow), {
                                    key: upgrade.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(TablistGrid, {
                                        columns: ['Upgrades', ''],
                                        class: "items-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_11, [
                                            _createVNode(_component_router_link, {
                                              to: '/store/membership-tiers/' + upgrade.id,
                                              target: "_blank"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(upgrade.attributes.tier_name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]),
                                          _createElementVNode("div", _hoisted_12, [
                                            _createVNode(_unref(XCircleIcon), {
                                              class: "cursor-pointer h-6 w-6 hover:text-black",
                                              onClick: $event => (deleteUpgrade(upgrade))
                                            }, null, 8, ["onClick"])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createBlock(_component_EmptyState, {
                            key: 1,
                            plural: "upgrades",
                            class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_NeueButton, {
                                type: "primary",
                                onClick: openUpgradeModal
                              }, {
                                default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                                  _createTextVNode("+ Upgrade", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(SettingsSection, {
                    title: "Downgrade",
                    description: "The tier members drop back to when they downgrade from this one."
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectInput, {
                        modelValue: local.downgrade,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((local.downgrade) = $event)),
                        name: "Downgrade tier",
                        options: [
                    { name: '(No downgrade)', value: null },
                    ...tiers.value.filter(x => x.id != tier.value.id).map(x => ({ name: x.attributes.tier_name, value: x.id }))
                  ],
                        onInput: _cache[24] || (_cache[24] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _unref(activeTab) === 'upgrades']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_13, [
                  _createVNode(SettingsSection, {
                    title: "Cart subscriptions",
                    description: "Let customers on this tier repeat their cart on a schedule.",
                    flush: ""
                  }, {
                    default: _withCtx(() => [
                      _cache[94] || (_cache[94] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Offer cart subscriptions"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Subscribers get automatic reminder texts, with optional autocharge. ")
                      ], -1)),
                      _createVNode(_component_NeueToggle, {
                        "model-value": cartSubscriptionEnabled.value,
                        disabled: waiting.cartSubscription,
                        "onUpdate:modelValue": setCartSubscription
                      }, null, 8, ["model-value", "disabled"])
                    ]),
                    _: 1
                  }),
                  (cartSubscriptionEnabled.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(SettingsSection, {
                          title: "Autocharge",
                          description: "Whether subscribed carts are charged automatically.",
                          flush: ""
                        }, {
                          default: _withCtx(() => [
                            _cache[95] || (_cache[95] = _createElementVNode("div", { class: "min-w-0" }, [
                              _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Autocharge"),
                              _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Charge each subscribed cart without the customer checking out. ")
                            ], -1)),
                            _createVNode(_component_NeueToggle, {
                              "model-value": autochargeEnabled.value,
                              disabled: waiting.autocharge,
                              "onUpdate:modelValue": setAutocharge
                            }, null, 8, ["model-value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(SettingsSection, {
                          title: "Intervals",
                          description: "How often customers can choose to have their cart repeat.",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            (intervals.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_unref(NeueTablist), null, {
                                    head: _withCtx(() => [
                                      _createVNode(_unref(TablistHeader), null, {
                                        default: _withCtx(() => [
                                          _createVNode(TablistGrid, {
                                            columns: ['Intervals', ''],
                                            header: "",
                                            class: "items-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _cache[97] || (_cache[97] = _createElementVNode("div", null, "Intervals", -1)),
                                              _createElementVNode("div", _hoisted_15, [
                                                _createVNode(_component_NeueButton, {
                                                  type: "secondary",
                                                  onClick: addInterval
                                                }, {
                                                  default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                                                    _createTextVNode("+ Interval", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervals.value, (interval) => {
                                        return (_openBlock(), _createBlock(_unref(TablistRow), {
                                          key: interval.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(TablistGrid, {
                                              columns: ['Intervals', ''],
                                              class: "items-center"
                                            }, {
                                              default: _withCtx(() => [
                                                (local.cartSubscription.intervals[interval.id])
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: "flex gap-2 text-gray-900",
                                                      onInput: _cache[25] || (_cache[25] = $event => (hasUnsavedChanges.value = true))
                                                    }, [
                                                      _createVNode(_component_InputField, {
                                                        modelValue: local.cartSubscription.intervals[interval.id].number,
                                                        "onUpdate:modelValue": $event => ((local.cartSubscription.intervals[interval.id].number) = $event),
                                                        class: "w-16"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                      _createVNode(_component_SelectInput, {
                                                        modelValue: local.cartSubscription.intervals[interval.id].string,
                                                        "onUpdate:modelValue": $event => ((local.cartSubscription.intervals[interval.id].string) = $event),
                                                        options: 
                                ['days', 'weeks', 'months', 'years'].map(x => ({
                                  name: local.cartSubscription.intervals[interval.id].number == 1 ? x.slice(0, -1) : x,
                                  value: x
                                }))
                              
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                                    ], 32))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_16, [
                                                  _createVNode(_unref(XCircleIcon), {
                                                    class: "cursor-pointer h-6 w-6 hover:text-black",
                                                    onClick: $event => (deleteInterval(interval))
                                                  }, null, 8, ["onClick"])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createBlock(_component_EmptyState, {
                                  key: 1,
                                  plural: "intervals",
                                  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_NeueButton, {
                                      type: "primary",
                                      onClick: addInterval
                                    }, {
                                      default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                                        _createTextVNode("+ Interval", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        }),
                        _createVNode(SettingsSection, {
                          title: "Subscription stores",
                          description: "The stores customers can subscribe to a cart from."
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stores.value, (store) => {
                              return (_openBlock(), _createBlock(_component_router_link, {
                                key: store.id,
                                to: '/store/stores/' + store.id,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NeueToggle, {
                                    "model-value": subscriptionStoreActive(store),
                                    name: store.attributes.store_name,
                                    description: store.attributes.store_description,
                                    disabled: waiting['subscription-store-' + store.id],
                                    "onUpdate:modelValue": $event => (subscriptionToggleStore(store))
                                  }, null, 8, ["model-value", "name", "description", "disabled", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createVNode(SettingsSection, {
                          title: "Defaults",
                          description: "The interval and store picked for customers when they subscribe."
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_SelectInput, {
                                modelValue: local.cartSubscription.defaultInterval,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((local.cartSubscription.defaultInterval) = $event)),
                                name: "Default interval",
                                options: [
                        { name: 'None', value: null },
                        ...intervals.value.map(x => ({
                          name:
                            x.attributes.setting_integer_value +
                            ' ' +
                            (x.attributes.setting_integer_value == 1
                              ? x.attributes.setting_string_value.slice(0, -1)
                              : x.attributes.setting_string_value),
                          value: x.id
                        }))
                      ],
                                onInput: _cache[27] || (_cache[27] = $event => (hasUnsavedChanges.value = true))
                              }, null, 8, ["modelValue", "options"]),
                              _createVNode(_component_SelectInput, {
                                modelValue: local.cartSubscription.defaultStore,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((local.cartSubscription.defaultStore) = $event)),
                                name: "Default store",
                                options: [
                        { name: 'None', value: null },
                        ...stores.value
                          .filter(x => storeSettings.value.some(y => y.attributes.setting_integer_value == x.id))
                          .map(x => ({
                            name: x.attributes.store_name,
                            value: x.id
                          }))
                      ],
                                onInput: _cache[29] || (_cache[29] = $event => (hasUnsavedChanges.value = true))
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(SettingsSection, {
                          title: "Drop template reminders",
                          description: "This drop template automatically gets copied for all of your production days. Customers automatically get paired with the subscription day based on their interval.",
                          plain: ""
                        }, {
                          default: _withCtx(() => [
                            (reminders.value?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createVNode(_unref(NeueTablist), null, {
                                    head: _withCtx(() => [
                                      _createVNode(_unref(TablistHeader), null, {
                                        default: _withCtx(() => [
                                          _createVNode(TablistGrid, {
                                            columns: ['Reminders', ''],
                                            header: "",
                                            class: "items-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _cache[100] || (_cache[100] = _createElementVNode("div", null, "Reminders", -1)),
                                              _createElementVNode("div", _hoisted_19, [
                                                _createVNode(_component_NeueButton, {
                                                  type: "secondary",
                                                  onClick: addReminder
                                                }, {
                                                  default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                                                    _createTextVNode("+ Reminder", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reminders.value, (reminder) => {
                                        return (_openBlock(), _createBlock(_unref(TablistRow), {
                                          key: reminder.id,
                                          class: "text-gray-700 cursor-pointer",
                                          onClick: $event => (openModal(reminder))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(TablistGrid, {
                                              columns: ['Reminders', ''],
                                              class: "items-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(reminderFormat(reminder)), 1),
                                                _createElementVNode("div", _hoisted_20, [
                                                  _createElementVNode("div", {
                                                    class: "truncate w-[12.5rem] cursor-pointer",
                                                    onClick: $event => (openModal(reminder))
                                                  }, _toDisplayString(reminderTemplate(reminder).attributes.body), 9, _hoisted_21),
                                                  _createVNode(_unref(XCircleIcon), {
                                                    class: "cursor-pointer h-6 w-6 hover:text-black",
                                                    onClick: $event => (deleteReminder(reminder))
                                                  }, null, 8, ["onClick"])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createBlock(_component_EmptyState, {
                                  key: 1,
                                  plural: "reminders",
                                  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_NeueButton, {
                                      type: "primary",
                                      onClick: addReminder
                                    }, {
                                      default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                                        _createTextVNode("+ Reminder", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        }),
                        _createVNode(SettingsSection, {
                          title: "Drop template autocharge",
                          description: "When each templated drop is charged."
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_22, [
                              _cache[102] || (_cache[102] = _createElementVNode("div", { class: "min-w-0" }, [
                                _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Autocharge")
                              ], -1)),
                              _createVNode(_component_NeueToggle, {
                                "model-value": templateAutochargeEnabled.value,
                                disabled: waiting.templateAutocharge,
                                "onUpdate:modelValue": setTemplateAutocharge
                              }, null, 8, ["model-value", "disabled"])
                            ]),
                            (templateAutocharge.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "flex items-center gap-2 border-t border-gray-100 pt-5",
                                  onInput: _cache[33] || (_cache[33] = $event => (hasUnsavedChanges.value = true))
                                }, [
                                  _cache[103] || (_cache[103] = _createTextVNode(" At ", -1)),
                                  _createVNode(_component_InputField, {
                                    modelValue: local.template.autocharge.time,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => ((local.template.autocharge.time) = $event)),
                                    type: "time",
                                    class: "w-32"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_SelectInput, {
                                    modelValue: local.template.autocharge.multiplier,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => ((local.template.autocharge.multiplier) = $event)),
                                    options: [
                        { name: 'this many days before the production day:', value: -1 },
                        { name: 'on the day of production', value: 0 },
                        { name: 'this many days after the production day:', value: 1 }
                      ]
                                  }, null, 8, ["modelValue"]),
                                  (local.template.autocharge.multiplier != 0)
                                    ? (_openBlock(), _createBlock(_component_InputField, {
                                        key: 0,
                                        modelValue: local.template.autocharge.days,
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => ((local.template.autocharge.days) = $event)),
                                        class: "w-16"
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                                ], 32))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(SettingsSection, {
                          title: "Drop template autofill",
                          description: "How each templated cart is filled."
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_NeueToggle, {
                              name: "Run before reminders",
                              "model-value": runBeforeEnabled.value('reminders'),
                              disabled: waiting['before-reminders'],
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = e => setRunBefore('reminders', e))
                            }, null, 8, ["model-value", "disabled"]),
                            _createVNode(_component_NeueToggle, {
                              name: "Run before autocharge",
                              "model-value": runBeforeEnabled.value('autocharge'),
                              disabled: waiting['before-autocharge'],
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = e => setRunBefore('autocharge', e))
                            }, null, 8, ["model-value", "disabled"]),
                            _createVNode(_component_SelectInput, {
                              modelValue: local.template.autofill,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => ((local.template.autofill) = $event)),
                              options: [
                      { name: 'Refill the cart from the last order', value: 'RefillAutofill' },
                      { name: 'Match the number of items in each category', value: 'CategoryAutofill' }
                    ],
                              onInput: _cache[37] || (_cache[37] = $event => (hasUnsavedChanges.value = true))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _unref(activeTab) === 'subscriptions']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                  _createVNode(SettingsSection, {
                    title: "Sign-up fee",
                    description: "A one-off fee customers pay when they join this tier."
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[104] || (_cache[104] = _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Charge a sign-up fee"),
                          _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Charged once, on the customer's first order on this tier. ")
                        ], -1)),
                        _createVNode(_component_NeueToggle, {
                          modelValue: local.membershipFee.oneTime.enabled,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => ((local.membershipFee.oneTime.enabled) = $event)),
                          onChange: _cache[39] || (_cache[39] = $event => (hasUnsavedChanges.value = true))
                        }, null, 8, ["modelValue"])
                      ]),
                      (local.membershipFee.oneTime.enabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_InputField, {
                              modelValue: local.membershipFee.oneTime.custom_name,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => ((local.membershipFee.oneTime.custom_name) = $event)),
                              name: "Fee name",
                              placeholder: "One-off Service Fee",
                              onInput: _cache[41] || (_cache[41] = $event => (hasUnsavedChanges.value = true))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_InputField, {
                              name: "Fee amount",
                              type: "number",
                              step: "0.01",
                              "model-value": local.membershipFee.oneTime.flat_rate_cents / 100,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = value => setMembershipFeeAmount('oneTime', value))
                            }, null, 8, ["model-value"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(SettingsSection, {
                    title: "Recurring fee",
                    description: "A fee customers pay again as they keep ordering on this tier."
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[105] || (_cache[105] = _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Charge a recurring fee"),
                          _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Charged again every set number of orders, or every set amount the customer spends on this tier. ")
                        ], -1)),
                        _createVNode(_component_NeueToggle, {
                          modelValue: local.membershipFee.recurring.enabled,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => ((local.membershipFee.recurring.enabled) = $event)),
                          onChange: _cache[44] || (_cache[44] = $event => (hasUnsavedChanges.value = true))
                        }, null, 8, ["modelValue"])
                      ]),
                      (local.membershipFee.recurring.enabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_InputField, {
                              modelValue: local.membershipFee.recurring.custom_name,
                              "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => ((local.membershipFee.recurring.custom_name) = $event)),
                              name: "Fee name",
                              placeholder: "Recurring Service Fee",
                              onInput: _cache[46] || (_cache[46] = $event => (hasUnsavedChanges.value = true))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_InputField, {
                              name: "Fee amount",
                              type: "number",
                              step: "0.01",
                              "model-value": local.membershipFee.recurring.flat_rate_cents / 100,
                              "onUpdate:modelValue": _cache[47] || (_cache[47] = value => setMembershipFeeAmount('recurring', value))
                            }, null, 8, ["model-value"]),
                            _createVNode(_component_SelectInput, {
                              modelValue: local.membershipFee.recurring.interval_type,
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => ((local.membershipFee.recurring.interval_type) = $event)),
                              name: "Interval type",
                              options: [
                      { name: 'Order Amount', value: 'order_amount' },
                      { name: 'Dollar Amount', value: 'dollar_amount' }
                    ],
                              onInput: _cache[49] || (_cache[49] = $event => (hasUnsavedChanges.value = true))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_InputField, {
                              modelValue: local.membershipFee.recurring.interval_amount,
                              "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => ((local.membershipFee.recurring.interval_amount) = $event)),
                              name: "Interval amount",
                              type: "number",
                              onInput: _cache[51] || (_cache[51] = $event => (hasUnsavedChanges.value = true))
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ], 512), [
                  [_vShow, _unref(activeTab) === 'membership-fees']
                ]),
                (local.pass.existsOnServer)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(SettingsSection, {
                        title: "Pass",
                        description: "Offer a recurring membership pass that grants rewards while the customer is subscribed.",
                        flush: ""
                      }, {
                        default: _withCtx(() => [
                          _cache[106] || (_cache[106] = _createElementVNode("div", { class: "min-w-0" }, [
                            _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Offer a pass"),
                            _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off unlinks the pass from this tier.")
                          ], -1)),
                          _createVNode(_component_NeueToggle, {
                            "model-value": local.pass.enabled,
                            disabled: waiting.passes,
                            "onUpdate:modelValue": setPasses
                          }, null, 8, ["model-value", "disabled"])
                        ]),
                        _: 1
                      }),
                      (local.pass.enabled)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(SettingsSection, {
                              title: "Pass details",
                              description: "How the pass is named and described to customers.",
                              onInput: _cache[54] || (_cache[54] = $event => (hasUnsavedChanges.value = true))
                            }, {
                              default: _withCtx(() => [
                                (local.pass.sharedTierCount > 1)
                                  ? (_openBlock(), _createBlock(NeueWell, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" This pass is shared with " + _toDisplayString(local.pass.sharedTierCount - 1) + " other tier" + _toDisplayString(local.pass.sharedTierCount - 1 === 1 ? '' : 's') + ". Changes here apply everywhere. ", 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_InputField, {
                                  modelValue: local.pass.name,
                                  "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => ((local.pass.name) = $event)),
                                  name: "Name",
                                  placeholder: "e.g. Premium Pass"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_InputArea, {
                                  modelValue: local.pass.description,
                                  "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => ((local.pass.description) = $event)),
                                  name: "Description",
                                  placeholder: "Describe the benefits of this pass"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(SettingsSection, {
                              title: "Pass configuration",
                              description: "What the pass costs, how often it bills, and whether checkout picks it for the customer.",
                              onInput: _cache[60] || (_cache[60] = $event => (hasUnsavedChanges.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_InputField, {
                                    modelValue: local.pass.billingPrice,
                                    "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => ((local.pass.billingPrice) = $event)),
                                    name: "Billing price",
                                    prefix: "$",
                                    type: "number",
                                    restrict: "monetary"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_SelectInput, {
                                    modelValue: local.pass.billingInterval,
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => ((local.pass.billingInterval) = $event)),
                                    name: "Billing interval",
                                    options: [
                        { name: 'Weekly', value: 'weekly' },
                        { name: 'Every 2 weeks', value: 'every_two_weeks' },
                        { name: 'Monthly', value: 'monthly' }
                      ],
                                    onInput: _cache[57] || (_cache[57] = $event => (hasUnsavedChanges.value = true))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _cache[107] || (_cache[107] = _createElementVNode("div", { class: "min-w-0" }, [
                                    _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Auto-select in checkout"),
                                    _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " When enabled, this pass will be automatically selected during checkout for eligible customers. ")
                                  ], -1)),
                                  _createVNode(_component_NeueToggle, {
                                    modelValue: local.pass.autoSelect,
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => ((local.pass.autoSelect) = $event)),
                                    onChange: _cache[59] || (_cache[59] = $event => (hasUnsavedChanges.value = true))
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(SettingsSection, {
                              title: "Rewards",
                              description: "What customers get while they hold the pass.",
                              plain: ""
                            }, {
                              default: _withCtx(() => [
                                (local.pass.rewards.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _createVNode(_unref(NeueTablist), null, {
                                        head: _withCtx(() => [
                                          _createVNode(_unref(TablistHeader), null, {
                                            default: _withCtx(() => [
                                              _createVNode(TablistGrid, {
                                                columns: [{ width: '1fr' }, { width: 'auto' }],
                                                header: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _cache[109] || (_cache[109] = _createElementVNode("div", null, "Rewards", -1)),
                                                  _createElementVNode("div", _hoisted_32, [
                                                    _createVNode(_component_NeueButton, {
                                                      type: "secondary",
                                                      onClick: addReward
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                                                        _createTextVNode("+ Reward", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(local.pass.rewards, (reward) => {
                                            return (_openBlock(), _createBlock(_unref(TablistRow), {
                                              key: reward.id,
                                              onClick: $event => (editReward(reward))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(TablistGrid, { columns: [{ width: '1fr' }, { width: 'auto' }] }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_33, [
                                                      _createElementVNode("div", _hoisted_34, _toDisplayString(rewardFormat(reward)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_35, [
                                                      _createVNode(_unref(XCircleIcon), {
                                                        class: "cursor-pointer h-6 w-6 hover:text-black flex-shrink-0",
                                                        onClick: _withModifiers($event => (deleteReward(reward)), ["stop"])
                                                      }, null, 8, ["onClick"])
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : (_openBlock(), _createBlock(_component_EmptyState, {
                                      key: 1,
                                      plural: "rewards",
                                      class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_NeueButton, {
                                          type: "primary",
                                          onClick: addReward
                                        }, {
                                          default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                                            _createTextVNode("+ Reward", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 512)), [
                      [_vShow, _unref(activeTab) === 'passes']
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_36, [
                  _createVNode(SettingsSection, {
                    title: "Meal plan",
                    description: "Offer a recurring meal plan that grants a set number of meals from a category each cycle.",
                    flush: ""
                  }, {
                    default: _withCtx(() => [
                      _cache[111] || (_cache[111] = _createElementVNode("div", { class: "min-w-0" }, [
                        _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Offer a meal plan"),
                        _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Customers on this tier pay for the plan and pick their included meals each cycle. ")
                      ], -1)),
                      _createVNode(_component_NeueToggle, {
                        modelValue: local.mealPlan.enabled,
                        "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => ((local.mealPlan.enabled) = $event)),
                        onChange: _cache[62] || (_cache[62] = $event => (hasUnsavedChanges.value = true))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (local.mealPlan.enabled)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(SettingsSection, {
                          title: "Billing",
                          description: "What the plan costs and how often it is billed."
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_InputField, {
                                name: "Price",
                                prefix: "$",
                                restrict: "monetary",
                                "model-value": local.mealPlan.priceCents / 100,
                                description: "Billed on this cadence for as long as the customer holds this tier.",
                                "onUpdate:modelValue": _cache[63] || (_cache[63] = 
                        v => {
                          local.mealPlan.priceCents = Math.round(parseFloat(v || 0) * 100)
                          hasUnsavedChanges.value = true
                        }
                      )
                              }, null, 8, ["model-value"]),
                              _createVNode(_component_SelectInput, {
                                name: "Billing cadence",
                                options: [
                        { name: 'Weekly', value: 'weekly' },
                        { name: 'Every two weeks', value: 'every_two_weeks' },
                        { name: 'Monthly', value: 'monthly' }
                      ],
                                "model-value": local.mealPlan.billingInterval,
                                "onUpdate:modelValue": _cache[64] || (_cache[64] = 
                        v => {
                          local.mealPlan.billingInterval = v
                          hasUnsavedChanges.value = true
                        }
                      )
                              }, null, 8, ["model-value"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(SettingsSection, {
                          title: "Meals",
                          description: "How many meals customers get, which category they come from, and when they are granted."
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_InputField, {
                                name: "Meals included",
                                restrict: "integer",
                                "model-value": local.mealPlan.itemCount,
                                description: "Meals granted each cycle.",
                                "onUpdate:modelValue": _cache[65] || (_cache[65] = 
                        v => {
                          local.mealPlan.itemCount = parseInt(v || 0)
                          hasUnsavedChanges.value = true
                        }
                      )
                              }, null, 8, ["model-value"]),
                              _createVNode(_component_SelectInput, {
                                name: "Meal category",
                                options: categoryOptions.value,
                                placeholder: "Choose a category",
                                "model-value": local.mealPlan.categoryId,
                                description: "Customers pick their included meals from this category.",
                                "onUpdate:modelValue": _cache[66] || (_cache[66] = 
                        v => {
                          local.mealPlan.categoryId = v
                          hasUnsavedChanges.value = true
                        }
                      )
                              }, null, 8, ["options", "model-value"]),
                              _createVNode(_component_SelectInput, {
                                name: "Meals granted",
                                options: [
                        { name: 'Weekly', value: 'weekly' },
                        { name: 'Every two weeks', value: 'every_two_weeks' },
                        { name: 'Monthly', value: 'monthly' }
                      ],
                                "model-value": local.mealPlan.grantInterval,
                                "onUpdate:modelValue": _cache[67] || (_cache[67] = 
                        v => {
                          local.mealPlan.grantInterval = v
                          hasUnsavedChanges.value = true
                        }
                      )
                              }, null, 8, ["model-value"]),
                              (local.mealPlan.grantInterval !== 'monthly')
                                ? (_openBlock(), _createBlock(_component_SelectInput, {
                                    key: 0,
                                    name: "Grant day",
                                    options: weekdayOptions,
                                    "model-value": local.mealPlan.grantDay,
                                    "onUpdate:modelValue": _cache[68] || (_cache[68] = 
                        v => {
                          local.mealPlan.grantDay = v
                          hasUnsavedChanges.value = true
                        }
                      )
                                  }, null, 8, ["model-value"]))
                                : _createCommentVNode("", true),
                              (local.mealPlan.grantInterval === 'monthly')
                                ? (_openBlock(), _createBlock(_component_InputField, {
                                    key: 1,
                                    name: "Grant date",
                                    restrict: "integer",
                                    description: "Day of the month (1-31).",
                                    "model-value": local.mealPlan.grantDate,
                                    "onUpdate:modelValue": _cache[69] || (_cache[69] = 
                        v => {
                          local.mealPlan.grantDate = parseInt(v || 1)
                          hasUnsavedChanges.value = true
                        }
                      )
                                  }, null, 8, ["model-value"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_SelectInput, {
                                name: "Unused meals",
                                options: rolloverOptions.value,
                                "model-value": local.mealPlan.rollover,
                                "onUpdate:modelValue": _cache[70] || (_cache[70] = 
                        v => {
                          local.mealPlan.rollover = v
                          hasUnsavedChanges.value = true
                        }
                      )
                              }, null, 8, ["options", "model-value"])
                            ])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _unref(activeTab) === 'meal-plans']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_39, [
                  _createVNode(SettingsSection, {
                    title: "Move members",
                    description: "Move all members to a different membership tier."
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_SelectInput, {
                          modelValue: local.moveTier,
                          "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => ((local.moveTier) = $event)),
                          class: "min-w-0 flex-1 sm:max-w-xs",
                          slim: true,
                          placeholder: "Select membership tier",
                          options: 
                      tiers.value
                        .filter(x => x.id != _unref(route).params.id)
                        .map(x => ({ name: x.attributes.tier_name, value: x.id }))
                    ,
                          disabled: local.membersMoved
                        }, null, 8, ["modelValue", "options", "disabled"]),
                        _createVNode(_component_NeueButton, {
                          type: local.membersMoved ? 'inactive' : 'secondary',
                          onClick: moveMembers
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Move" + _toDisplayString(local.membersMoved ? 'd' : ''), 1)
                          ]),
                          _: 1
                        }, 8, ["type"]),
                        (local.membersMoved)
                          ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                              key: 0,
                              class: "h-5 w-5"
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  (tier.value?.attributes.type !== 'FreeMembershipTier' && tier.value?.attributes.type !== 'NoMembershipTier')
                    ? (_openBlock(), _createBlock(SettingsSection, {
                        key: 0,
                        title: "Delete tier",
                        description: "Remove this membership tier."
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[113] || (_cache[113] = _createElementVNode("div", { class: "min-w-0" }, [
                              _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Delete membership tier"),
                              _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Removes this tier. This cannot be undone.")
                            ], -1)),
                            _createVNode(_component_NeueButton, {
                              type: "red",
                              onClick: deleteTier
                            }, {
                              default: _withCtx(() => [...(_cache[112] || (_cache[112] = [
                                _createTextVNode("Delete", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _unref(activeTab) === 'actions']
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_PageFooter, { "content-width": "max-w-[1040px]" }, {
            right: _withCtx(() => [
              (hasUnsavedChanges.value)
                ? (_openBlock(), _createBlock(_component_NeueButton, {
                    key: 0,
                    type: "primary",
                    onClick: save
                  }, {
                    default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                      _createTextVNode("Save", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/store/membership-tiers"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NeueButton, { type: "primary" }, {
                        default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                          _createTextVNode("Done", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

}